import { Injectable } from '@angular/core';
import { AggregatorService } from '@services/aggregator/1.0/aggregator.service';
import { UtilitiesService } from '@services/utilities/1.0/utilities.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AggregatorPipeService {
  aggregators: BehaviorSubject<any> = new BehaviorSubject({});

  constructor(
    private aggregatorService: AggregatorService,
    private utilitiesService: UtilitiesService,
  ) {
    this.aggregatorService.getAggregators().subscribe(this.publish.bind(this));
  }

  getAggregators() {
    return this.aggregators;
  }

  publish(data) {
    const dictionary = this.utilitiesService.convertArrayToMap(data, 'id');
    this.aggregators.next(dictionary);
  }
}
